<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">提取FRM绑定码信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据FRM提供的绑定码信息，绑定本地终端需要关联的项目人员组的信息。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool __stdcall SKFaceGetBindFrmInfo(const char *pszBindCode, 
	SKFaceGetBindCodeInfoCallback funcGetCodeInfoCallback);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pszBindCode：FRM绑定码</p>
        <p class="doc_main_p">
        	（2）funcGetCodeInfoCallback：获取FRM绑定信息（比如项目名称、人员组名称...）回调接口
        </p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	（1）bool类型，true表示成功，可处理回调结果；false表示失败（绑定码格式有误），无需处理回调（回调不返回信息）。
		</p>
		<p class="doc_main_p">
			（2）funcGetCodeInfoCallback类型typedef void(__stdcall *SKFaceGetBindCodeInfoCallback ) (int nCode, const char *pszMsg):
nCode错误码，0：获取绑定码信息成功；其他：获取绑定码信息失败，pszMsg为绑定码FRM信息（比如项目名称、人员组名称...），code非0时为错误信息。json字符串格式需解析使用。
		</p>
		<h3 class="doc_main_h3">错误码列表</h3>
		<get-frm-bind-code-error-list :propsTableData="errorCodeList"></get-frm-bind-code-error-list>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">void FuncGetBindCodeInfo(int nCode, const char *pszMsg)
{
    printf("GetBindCodeInfoCallback:code=%d,msg=%s\n",nCode,pszMsg);
}
bool bRet = SKFaceGetBindFrmInfo("xxxxxxx",FuncGetBindCodeInfo);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import GetFRMBindCodeErrorList from '../../../../components/getFRMBindCodeErrorList'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'get-frm-bind-code-error-list':GetFRMBindCodeErrorList,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Windows','FRM接口','提取FRM绑定码信息'],
				errorCodeList:[
					{"code":"0","msg":"成功"},
					{"code":"10003","msg":"要绑定的分组不存在"},
					{"code":"20004","msg":"网络请求失败"},
					{"code":"20005","msg":"网络请求失败"},
					{"code":"20006","msg":"网络请求失败"},
					{"code":"20022","msg":"网络请求失败"},
					{"code":"20024","msg":"网络请求失败"},
					
				]
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacewindows/frm/getFRMBindCode.vue